import { Component, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-worker-service-terms',
  templateUrl: './worker-service-terms.component.html',
  styleUrls: ['./worker-service-terms.component.scss'],
})
export class WorkerServiceTermsComponent {
  // service description for the service provided by the worker
  @Input() information: { definition: string | string[]; additionalText?: string };

  // service provided by the worker
  @Input() serviceName: string;

  @Input() dialog: []; // dialog is the array of service description strings

  constructor(private popoverCtrl: PopoverController) {}

  /**
   * Close the popup modal.
   */
  closeModal() {
    this.popoverCtrl.dismiss();
  }
}
